export default __webpack_public_path__ + "media/images/app-icon-5f36958477acf6ed942a04621034b8ee.svg";